/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Pain_Item31Inputs */

const ja_playdata_eventreport_pain_item31 = /** @type {(inputs: Playdata_Eventreport_Pain_Item31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント中のチームごとの視聴者数を知りたい`)
};

const en_playdata_eventreport_pain_item31 = /** @type {(inputs: Playdata_Eventreport_Pain_Item31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to know per-team viewer numbers during an event`)
};

/**
* | output |
* | --- |
* | "I want to know per-team viewer numbers during an event" |
*
* @param {Playdata_Eventreport_Pain_Item31Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_pain_item31 = /** @type {((inputs?: Playdata_Eventreport_Pain_Item31Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Pain_Item31Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_pain_item31(inputs)
	return en_playdata_eventreport_pain_item31(inputs)
});
export { playdata_eventreport_pain_item31 as "playdata_eventReport_pain_item3" }